import React, { useState } from "react";
import PT_Report_Filter from "./pt_report_filter/PT_Report_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import PT_Report_Table from "./pt_report_table/PT_Report_Table";
import { useDispatch, useSelector } from "react-redux";
import { GetNonConformingReport } from "../../../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const PT_Report = ({
  setSearchParams,
  reportgenerate,
  validitydetails,
  setCurrentPage,
  currentPage,
}) => {
  const [show, setShow] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
      const haveReportPermission = permissions?.includes(
        FixIDS.pt_report.Report,
      );

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <PT_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <PT_Report_Table
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>
    </section>
  );
};

export default PT_Report;
